import { FETCH_BOOKMARKS_BY_TYPE, FETCH_BOOKMARKS_DATA } from '../actions';

export function bookmarksByTypeReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_BOOKMARKS_BY_TYPE:
      return action.payload;
    default:
      return state;
  }
}

export function bookmarksDataReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_BOOKMARKS_DATA:
      return action.payload;
    default:
      return state;
  }
}
